import "./style.scss";
import {ReactComponent as LinkArrow} from "../../../assets/icons/linkArrow.svg";
import {Link} from "react-router-dom";
import { useEffect } from "react";

const StatsSection = ({items = []}) => {
  let last = false;
  return <div className="statsSection">
    {items.map((item, i) => {
      if(items.length-1 == i) last = true;
      return<> 
      <div className="statBox">
        <div className="stat">
          <p className="label"> 
            {item.label} {(!("redirect" in item) ? "" : (<Link to={item.redirect}><LinkArrow/></Link>))}
          </p>
          <p className={!("gain" in item) ? "value" : (item.gain ? "value green" : "value red")}>{item.value}</p>
          <p className="description"> {item.description}</p>
        </div>
      </div>

      {!last &&  <div className="separator"/>}
      </>
    }
    )}
  </div>
}

export default StatsSection;